"use strict";

var React = require("react");

var SvgIconCheckCircleBlueV1 = function SvgIconCheckCircleBlueV1() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 16 16",
    },
    /*#__PURE__*/ React.createElement(
      "g",
      {
        fill: "none",
        fillRule: "evenodd",
      },
      /*#__PURE__*/ React.createElement("path", {
        d: "M-1-1h18v18H-1z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d:
          "M8 .5C3.86.5.5 3.86.5 8c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5C15.5 3.86 12.14.5 8 .5zM6.5 11.75L2.75 8l1.058-1.058L6.5 9.627l5.693-5.692L13.25 5 6.5 11.75z",
        fill: "currentColor",
      })
    )
  );
};

exports["foreignIcon"] = SvgIconCheckCircleBlueV1;
